/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCircleSquareInSquare: {
  name: 'circle-square-in-square';
  data: string;
} = {
  name: 'circle-square-in-square',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3Zm-9 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-1 4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-5Z" fill="currentColor"/></svg>`,
};
